<template>
	<input-form action="/json/reset" @submit="$navigate('/')" @loading="$emit('loading', $event)" :unsaveable="true" v-slot="props" :object-data="reset">
		<p>Enter the code you received in the email along with a new password to reset your account.</p>
		<input-text ref="start" v-model="props.object.code" :errors="props.errors.code" label="Reset Code" prepend-icon="essentials/security/safe" placeholder="Reset Code"></input-text>
		<input-password v-model="props.object.password" :errors="props.errors.password" label="New Password" placeholder="New Password" prepend-icon="essentials/security/key"></input-password>
		<input-password v-model="props.object.password_v" :errors="props.errors.password" label="Reenter New Password" placeholder="Reenter New Password" prepend-icon="essentials/security/keyhole-circle"></input-password>
		<button type="submit" :disabled="props.loading > 0" class="secondary block">Reset Password</button>
	</input-form>
</template>

<script>
	export default {
		data() {
			return {
				reset: {}
			};
		},
		watch: {
			'$route.query': {
				handler() {
					this.reset.key = this.$route.query.key;
				},
				immediate: true
			}
		}
	}
</script>